var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveFavouriteSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,2c-2.6679688,0-4.8066406,1.0595703-6.5,3.2294922C14.3066406,3.0595703,12.1679688,2,9.5,2 C4.8134766,2,1,5.8134766,1,10.5c0,3.8691406,2.1757812,8.0898438,6.2929688,12.2070312L13.5859375,29 C14.2304688,29.6445312,15.0878906,30,16,30s1.7695312-0.3554688,2.4140625-1l6.2929688-6.2929688 C28.8242188,18.5898438,31,14.3691406,31,10.5C31,5.8134766,27.1865234,2,22.5,2z M23.2929688,21.2929688L17,27.5859375 c-0.5351562,0.5332031-1.4648438,0.5332031-2,0l-6.2929688-6.2929688C4.9736328,17.5595703,3,13.8271484,3,10.5 C3,6.9160156,5.9160156,4,9.5,4c2.4443359,0,4.1845703,1.0839844,5.6425781,3.5146484 c0.3613281,0.6015625,1.3535156,0.6015625,1.7148438,0C18.3154297,5.0839844,20.0556641,4,22.5,4c3.5839844,0,6.5,2.9160156,6.5,6.5 C29,13.8271484,27.0263672,17.5595703,23.2929688,21.2929688z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFavouriteSmall);
export default __webpack_public_path__ + "static/media/save-favourite--small.6392393668a15da3edbdfcd7a509fba3.svg";
export { ForwardRef as ReactComponent };